import HeaderMenu from './HeaderMenu'

function Header() {
  return (
    <header className='header'>
      <HeaderMenu />
    </header>
  )
}

export default Header
